import IconWithPopup from './iconWithPopup'

export { IconWithPopup }
